import { TourConfig } from 'components/tour/tour.types';

export const AI_REQUESTS_TOUR_CONFIG: TourConfig = {
  id: 'ai-request-tour',
  version: 1,
  steps: [
    {
      target: 'create-request-ai_assist',
      title: 'ИИ заполнит заявку, пока Вы разговариваете',
      description:
        'Нажмите «Создать с ИИ» — система соберёт данные и оформит заявку, пока Вы уточняете детали у жильца. После звонка Вы сможете проверить и при необходимости скорректировать заявку. Такие заявки отмечаются тегом «ИИ-помощь» синего цвета. Для работы функционала необходимо подключение услуги «Телефония».',
      side: 'top',
    },
    {
      target: 'create-request-auto_request',
      title: 'Отправьте создание заявки ИИ и продолжайте работать',
      description:
        'Нажмите «Передать ИИ», чтобы система оформила заявку в фоновом режиме. Вы сможете перейти к следующему звонку — всё остальное сделает ИИ. Готовые заявки появятся в списке с тегом «Автозаявка» синего цвета. Для работы функционала необходимо подключение услуги «Телефония».',
      side: 'top',
    },
  ],
};
